import React, { useState, useEffect, useCallback } from "react";

import { Box, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  fancyTimeFormat,
  getFormatedDate,
  orderByTime,
} from "../../../Js/TimeAndDate";
import { makeStyles } from "@material-ui/core/styles";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReadMore from "../../../Js/ReadMore";
import Placeholder from "../../../Components/UI/Placeholder";

const TrainerDetailTable = (props) => {
  const styles = useStyles();

  //State
  const [tableDetailData, setTableDetailData] = useState([]);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    initialRender();
  }, [props]);

  const initialRender = useCallback(async () => {
    console.log("props.tableDetailData.length", props.tableDetailData);
    setTableDetailData([]);
    if (props.tableDetailData.length > 0) {
      let uniqueDateWiseData = [
        ...new Set(props.tableDetailData.map((item) => item.created_at)),
      ];
      // console.log("uniqueDateWiseData===>", uniqueDateWiseData);

      uniqueDateWiseData.sort(function compare(a, b) {
        let dateA = new Date(b);
        let dateB = new Date(a);
        return dateA - dateB;
      });

      let dateWiseData = [];
      uniqueDateWiseData.forEach((itemData) => {
        let logData = props.tableDetailData.filter((obj) => {
          return obj.created_at === itemData;
        });
        let totalTime = logData.reduce((acc, val) => {
          return acc + Number(val.sum);
        }, 0);
        let obj = {
          date_data: itemData,
          totalTime: totalTime,
          data: orderByTime(logData, "desc"),
        };
        console.log("obj", obj);
        dateWiseData.push(obj);
      });
      // console.log("dateWiseData===>", dateWiseData);
      setTableDetailData(dateWiseData);
    }
  }, [props]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box>
      {tableDetailData && tableDetailData.length > 0 && (
        <>
          {tableDetailData.map((objSection, index) => {
            return (
              <Accordion
                expanded={expanded === "panel" + index}
                onChange={handleChange("panel" + index)}
                sx={{ backgroundColor: "#F5F7FF", boxShadow: 0, my: 1 }}
                key={`accordion_${index}`}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
                  aria-controls={`panel${index}bh-content`}
                  id={`panel${index}bh-header`}
                >
                  <Typography
                    sx={{
                      width: "75%",
                      color: "#DB8829",
                      fontSize: "0.9rem",
                      fontWeight: "600",
                    }}
                  >
                    Date: {getFormatedDate(objSection.date_data, "DD MMM YYYY")}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.9rem",
                      color: "#A9A9A9",
                      "@media (min-width: 1636px)": { fontSize: "1rem" },
                    }}
                  >
                    Total Time: {fancyTimeFormat(objSection.totalTime) + " m"}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer
                    sx={{
                      height: "35vh",
                      overflow: "auto",
                      pr: 2,
                    }}
                    className={styles.scrollBar}
                  >
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              color: "#DB8829",
                              fontSize: "1rem",
                              fontWeight: "600",
                              padding: "5px",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            Item
                          </TableCell>
                          {props.tabValue == "presentation" && (
                            <>
                              <TableCell
                                sx={{
                                  color: "#DB8829",
                                  fontSize: "1rem",
                                  fontWeight: "600",
                                  padding: "5px",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.4rem",
                                  },
                                }}
                              >
                                Class Name
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: "#DB8829",
                                  fontSize: "1rem",
                                  fontWeight: "600",
                                  padding: "5px",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "1.4rem",
                                  },
                                }}
                              >
                                Topic
                              </TableCell>
                            </>
                          )}

                          <TableCell
                            align="center"
                            sx={{
                              color: "#DB8829",
                              fontSize: "1rem",
                              fontWeight: "600",
                              padding: "1px",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            Duration
                          </TableCell>
                          <TableCell
                            align="center"
                            sx={{
                              color: "#DB8829",
                              fontSize: "1rem",
                              fontWeight: "600",
                              padding: "1px",
                              "@media (min-width: 1636px)": {
                                fontSize: "1.4rem",
                              },
                            }}
                          >
                            Time
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {objSection.data.length > 0 &&
                          objSection.data.map((detailData, index) => {
                            return (
                              <TableRow key={index}>
                                <TableCell
                                  sx={{
                                    color: "#DB8829",
                                    fontSize: "0.9rem",
                                    fontWeight: "500",
                                    padding: "10px",
                                    "@media (min-width: 1636px)": {
                                      fontSize: "1.2rem",
                                    },
                                  }}
                                >
                                  {detailData.title}
                                </TableCell>

                                {props.tabValue == "presentation" && (
                                  <>
                                    <TableCell
                                      sx={{
                                        color: "#DB8829",
                                        fontSize: "0.9rem",
                                        fontWeight: "500",
                                        padding: "10px",
                                        "@media (min-width: 1636px)": {
                                          fontSize: "1.2rem",
                                        },
                                      }}
                                    >
                                      {detailData?.context?.className || "-"}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        color: "#DB8829",
                                        fontSize: "0.9rem",
                                        fontWeight: "500",
                                        padding: "10px",
                                        "@media (min-width: 1636px)": {
                                          fontSize: "1.2rem",
                                        },
                                      }}
                                    >
                                      <ReadMore
                                        text={
                                          detailData?.context?.topicPath || "-"
                                        }
                                        maxChars={"30"}
                                      />
                                    </TableCell>
                                  </>
                                )}
                                <TableCell
                                  align="center"
                                  sx={{
                                    color: "#DB8829",
                                    fontSize: "0.9rem",
                                    fontWeight: "500",
                                    padding: "10px",
                                    "@media (min-width: 1636px)": {
                                      fontSize: "1.2rem",
                                    },
                                  }}
                                >
                                  {fancyTimeFormat(detailData.sum) + " m"}
                                </TableCell>
                                <TableCell
                                  align="center"
                                  sx={{
                                    color: "#DB8829",
                                    fontSize: "0.9rem",
                                    fontWeight: "500",
                                    padding: "10px",
                                    "@media (min-width: 1636px)": {
                                      fontSize: "1.2rem",
                                    },
                                  }}
                                >
                                  {getFormatedDate(
                                    detailData.attempttime,
                                    "HH:mm:ss"
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </>
      )}
      {tableDetailData && tableDetailData.length == 0 && (
        <Placeholder
          primaryText="No trainer data found"
          secondaryText="No trainer data found!"
          image="assign"
        ></Placeholder>
      )}
    </Box>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.5em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default TrainerDetailTable;
